import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { NetworkQualityType } from '../../constants';

type NetworkQualityState = {
    networkQualityType?: NetworkQualityType;
    badNetworkQualityNotificationWasShown: boolean;
};

const initialState: NetworkQualityState = {
    badNetworkQualityNotificationWasShown: false,
};

const networkQualitySlice = createSlice({
    name: 'networkQuality',
    initialState,
    reducers: {
        setNetworkQualityType(state, action: PayloadAction<NetworkQualityType>) {
            state.networkQualityType = action.payload;
        },
        setBadNetworkQualityNotificationWasShown(state, action: PayloadAction<boolean>) {
            state.badNetworkQualityNotificationWasShown = action.payload;
        },
        resetNetworkQuality() {
            return initialState;
        },
    },
});

export const { setNetworkQualityType, setBadNetworkQualityNotificationWasShown, resetNetworkQuality } =
    networkQualitySlice.actions;
export const networkQualityReducer = networkQualitySlice.reducer;
